// Temporary client-side cap on requested_pickup_time_range while queryOrders allows wider spans.
// History looks back this many years; Today looks forward the same amount. Ideally we remove this
// clipping once product and API agree on unconstrained ranges.
export const MAX_REQUESTED_PICKUP_TIME_RANGE_YEARS = 2;

export const DEFAULT_PARTNER_ORDERS_PAGE_SIZE = 50;

export const PARTNER_ORDERS_TAB = {
  TODAY: 'today',
  HISTORY: 'history',
};

export {
  LIFECYCLE_STATUS,
  MARKED_FULFILLED_TYPE,
  ORDER_ITEM_CANCELLATION_TYPE,
  PROCESSING_STATUS,
} from '../shared/SkuEnumHelpers';
